////
/// ============================================================================
/// COMPONENT / Swiper Product Archive
/// ============================================================================
///
/// @link https://swiperjs.com/
/// @link https://codepen.io/xgad/post/svg-radial-progress-meters
/// @group components
////

import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);

export default () => {

    let container = document.querySelector('.js-gallery');

    if (!container) {
        return;
    }

    new Swiper(container,{
        pagination: {
            el: '.swiper-pagination',
            dynamicBullets: !0,
            clickable: !0
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });

};
